<template>
    <div>
        <nav class="level is-mobile">
            <div class="level-left">
                <div class="level-item">

<!--                    {{levelTitle}}-->
<!--                    {{levelSelected}}-->
                </div>
                <div class="level-item" v-if= "levelSelected">
                    <b-tooltip label="Edit"  >
                       <b-button type="is-warning"
                                 icon-right="pencil"
                                 :disabled= "!levelSelected"
                                 @click="showEditAddDxCode"
                       />
                    </b-tooltip>
                </div>
                <div class="level-item">
                    <i class="has-text-grey" v-if="levelSelected">{{levelSelected.name}}</i>
                </div>
                <div class="level-item">
                    <i class="has-text-grey-light" v-if="levelSelected">{{levelSelected.code}}</i>
                </div>
            </div>
            <div class="level-right">
                <div class="level-item">
                    <b-tooltip label="Add New"  >
                        <b-button type="is-success"
                                  icon-right="plus"
                                  v-if="openPlus"
                                  @click="addNew"
                        />
                    </b-tooltip>
                </div>

                <div class="level-item">
                    <b-tooltip label="Reload"  >
                        <b-button type="is-warning  is-light"
                                  icon-right="reload"
                                  v-if="openPlus"
                                  @click="reload"
                        />
                    </b-tooltip>
                </div>

            </div>

        </nav>

        <EditAddDxCode
                 v-if="isShowEditAddDxCode"
                 :mode="modeEditAddDxCode"
                 :level ="level"
                 :dataToEdit = "levelSelected"
                 :idparent="idparent"
                 @closeEditAddDxCode="closeEditAddDxCode"
                 @closeEditAddDxCodeWithDataChange="closeEditAddDxCodeWithDataChange"
        />

    </div>

</template>

<script>

    import EditAddDxCode from "./EditAddDxCode";
    export default {
        name: "HeadPanel",
        components:{
            EditAddDxCode
        },
        props:{
            idparent :String,
            level:Number,
            levelTitle : String,
            levelSelected : Object  // { "id": "11e41c985f74", "idparent": null, "name": "Neoplasia", "code": "A000-A016", "status": "Y" }
        },
        computed:{
            openPlus:function () {
                if(this.level === 1 && this.idparent === null){
                    return true
                }  else{
                    if(this.idparent === null){
                        return  false
                    }else{
                        return  true
                    }
                }
            }
        },
        methods:{
            reload(){
                this.$emit('reloadEach', {"idparent": this.idparent,"level":this.level})
            },
            closeEditAddDxCodeWithDataChange(payload){
                // payload {"idparent": "","level":""}

                // console.log('closeEditAddDxCodeWithDataChange')
                this.isShowEditAddDxCode = false
                this.$emit('closeEditAddDxCodeWithDataChange',payload)
            },
            addNew(){
                this.modeEditAddDxCode = 1
                this.isShowEditAddDxCode = true
            },
            closeEditAddDxCode(){
                this.isShowEditAddDxCode = false
            },
            showEditAddDxCode(){
                this.modeEditAddDxCode = 2
                this.isShowEditAddDxCode = true
            }
        },
        data(){
            return {
                isShowEditAddDxCode : false,
                modeEditAddDxCode : 1 ,  // default insert

            }
        }
    }
</script>

<style scoped>

</style>